var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 331.51,
    height: 331.512,
    viewBox: "0 0 331.51 331.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 88.462) rotate(-20)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.321,258.649A129.324,129.324,0,1,1,258.646,129.324,128.466,128.466,0,0,1,129.321,258.649m0-252.765A123.441,123.441,0,1,0,252.763,129.324,123.579,123.579,0,0,0,129.321,5.883",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.564,
    height: 15.564,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 104.649, 168.059)",
    fill: "#db0a0b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.564,
    height: 15.564,
    transform: "translate(117.727 154.578) rotate(-44.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.568,
    height: 15.568,
    transform: "translate(118.315 127.373) rotate(-44.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.808,143.549l11,11.009,11.006-11.009-11.006-11Z",
    transform: "translate(-2.081 -2.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.566,
    height: 15.566,
    transform: "translate(91.128 154.57) rotate(-45.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.075,171.283h22.009l-11-11Z",
    transform: "translate(-1.541 -3.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.537,143.549l11.005,11.009,11-11.009-11-11Z",
    transform: "translate(-2.621 -2.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.566,
    height: 15.566,
    transform: "translate(145.511 154.57) rotate(-45.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.537,171.283h22.009l-11-11Z",
    transform: "translate(-2.621 -3.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.267,171.283h22.012l-11.006-11Z",
    transform: "translate(-3.161 -3.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.526,248.668a119.142,119.142,0,1,1,119.14-119.143,119.276,119.276,0,0,1-119.14,119.143m0-235.342A116.2,116.2,0,1,0,211.69,47.36a116.331,116.331,0,0,0-82.164-34.034",
    transform: "translate(-0.202 -0.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.223,133.789l.145,7.3-3.9.077-.123-6.178-2.91.058.123,6.178-3.437.068-.144-7.32-3.034.06.223,11.248,16.3-.323-.223-11.226Z",
    transform: "translate(-1.402 -2.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.613,113.41l9.375,3.872L75.412,118.74l-1.5,3.632,15.065,6.222,1.5-3.632L81.1,121.09l11.579-1.467,1.492-3.611L79.11,109.789Z",
    transform: "translate(-1.44 -2.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.438,90.116l-5.526,3.1-1.835-3.271,6.082-3.412-1.485-2.646-9.51,5.336,7.976,14.215,3.427-1.923-3.177-5.662,5.525-3.1Z",
    transform: "translate(-1.913 -1.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6,88.673a4.9,4.9,0,0,0,1.941-2.039,5.282,5.282,0,0,0,.372-2.877,4.358,4.358,0,0,0-2.026-3.432,7.165,7.165,0,0,0-4.648-.778l-6.375.709,1.8,16.2,3.905-.434-.637-5.73,2.114-.235,3.5,5.412,4.183-.465-.018-.167Zm-1.922-2.431a2.233,2.233,0,0,1-1.609.772l-2.47.275-.5-4.461,2.47-.276a2.211,2.211,0,0,1,1.736.412,2.3,2.3,0,0,1,.75,1.583,2.274,2.274,0,0,1-.38,1.7",
    transform: "translate(-2.316 -1.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.3,81.512,137.587,95.177l3.994,1.293,1.833-2.607,5.123,1.659-.032,3.191,4.015,1.3L151.81,82.65Zm.281,10.836-3.334-1.08,3.4-4.841Z",
    transform: "translate(-2.681 -1.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.362,97.046l-6.9,7.431,2.678-11.355-2.879-2.674-11.094,11.943,2.88,2.674,6.9-7.431L163.276,109l2.863,2.658,11.094-11.943Z",
    transform: "translate(-3.043 -1.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.451,126.274l-1.517-3.6a2.707,2.707,0,0,1-2.163.084,3.012,3.012,0,0,1-1.391-1.661,2.394,2.394,0,0,1,.156-2.513,7.809,7.809,0,0,1,3.181-2.051l1.063-.447a7.06,7.06,0,0,1,3.508-.7,2.346,2.346,0,0,1,1.844,1.555,3.087,3.087,0,0,1,.237,2.234,2.924,2.924,0,0,1-1.68,1.521l1.52,3.611a6.17,6.17,0,0,0,3.172-3.558,7.025,7.025,0,0,0-.412-5,6.7,6.7,0,0,0-2.311-2.963,6.324,6.324,0,0,0-3.49-1.135,9.877,9.877,0,0,0-4.188.859l-.742.313a8.648,8.648,0,0,0-4.732,4,6.4,6.4,0,0,0,.035,5.476,8.043,8.043,0,0,0,2,2.915,5.55,5.55,0,0,0,2.777,1.387,5.957,5.957,0,0,0,3.128-.321",
    transform: "translate(-3.33 -2.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.15,133.667l-.182,11.227,3.024.049.118-7.3,3.895.063-.1,6.179,2.909.047.1-6.179,3.436.055-.118,7.322,3.034.049.181-11.249Z",
    transform: "translate(-3.409 -2.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.646,124.743c-1.5-1.787-3.7-2.651-6.588-2.578a6.653,6.653,0,0,0-4.033,1.35,6.159,6.159,0,0,0-2.1,3.274,6.071,6.071,0,0,0-2.342-2.72,7,7,0,0,0-3.949-.954,6.992,6.992,0,0,0-5.991,3.138c-1.328,2-1.949,4.914-1.849,8.661l.281,10.565L56.27,144.7l.123,0-.318-11.923c-.122-3.55-.938-6.253-2.429-8.031m-17.853,5.582a2.82,2.82,0,0,1,2.219.873,5.105,5.105,0,0,1,.9,3.175L39,137.9l-6.482.173-.088-3.31a5.585,5.585,0,0,1,.7-3.361,3.032,3.032,0,0,1,2.529-1.077c.046,0,.091,0,.135,0m11.482-.927a2.9,2.9,0,0,1,2.255.914,4.278,4.278,0,0,1,.914,2.813l.12,4.47-6.722.178-.128-4.788c-.049-2.349,1.076-3.522,3.439-3.586l.124,0",
    transform: "translate(-0.522 -2.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.149,95.429,30.876,102.3,58.6,111.471l.116.038,2.273-6.868L33.265,95.467Z",
    transform: "translate(-0.602 -1.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2,74.125,65.377,84.532,60.017,80.5l6.553-8.713.074-.1L62.4,68.5l-.1-.074-6.626,8.809-4.7-3.537,7.777-10.342.074-.1L54.4,59.927l-.1-.073L42.159,75.993l-.074.1L65.423,93.645l.1.073L77.635,77.611l.074-.1L73.3,74.2Z",
    transform: "translate(-0.82 -1.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.653,37.641,93.327,53.13,75.908,42.608l-.061-.036-6.286,3.52L83.891,71.677l6.33-3.546L81.545,52.642,98.982,63.155l.061.037,6.251-3.5L90.964,34.106Z",
    transform: "translate(-1.355 -0.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.766,26.693l-4.206,21.18-7.11-20.284-.03-.088-8.013.569,11.809,28.475.033.081,7.825-.556L137.8,26.285l.043-.165-7.979.567Z",
    transform: "translate(-2.151 -0.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.228,37.3l12.212,4.275.116.04,1.869-5.339L157.365,29.6l-.116-.04L147.6,57.123l-.04.116,19.023,6.66.117.04,1.861-5.32-12.289-4.3,2.216-6.328,10.29,3.6.116.04,1.8-5.131-10.4-3.643Z",
    transform: "translate(-2.875 -0.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.952,63.414l-5.194-4.858-.089-.084-12.13,12.963,4.743-19.788.018-.07-5.172-4.839-.089-.083-19.95,21.323-.084.09,5.208,4.872.089.084,12.13-12.964-4.729,19.8-.018.07,5.143,4.81.089.084L211.867,63.5Z",
    transform: "translate(-3.39 -0.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.949,111.589a11.848,11.848,0,0,0,4.368-.9l17.693-7.019.114-.045-2.675-6.744-17.768,7.049a5.515,5.515,0,0,1-3.944.4,4.2,4.2,0,0,1-2.26-2.552c-1.039-2.624-.145-4.5,2.734-5.722l17.952-7.121.114-.045-2.69-6.78L206.65,89.224a9.984,9.984,0,0,0-5.936,5.751c-.964,2.589-.786,5.577.524,8.882a14.127,14.127,0,0,0,3.429,5.251,9.084,9.084,0,0,0,4.874,2.377,9.311,9.311,0,0,0,1.409.1",
    transform: "translate(-3.899 -1.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.291,124.616l-.123,0-.58,20.146,0,.122,5.635.163.376-13.015,6.7.193-.314,10.9,0,.123,5.435.156.318-11.019,5.884.17-.373,12.933,0,.123,5.656.164.582-20.187,0-.123Z",
    transform: "translate(-4.025 -2.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.111,227.363A94.932,94.932,0,0,1,40.44,163.528l2.78-.962a91.957,91.957,0,0,0,173.782,0l2.781.962a94.934,94.934,0,0,1-89.671,63.836",
    transform: "translate(-0.788 -3.167)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.92d6933523023cea37dcbcbb7f8af5b6.svg";
export { ForwardRef as ReactComponent };